<template>
  <div class="wrap1" v-loading.fullscreen.lock="loading">
    <h2 class="common-title">
      <span
        ><i class="el-icon-arrow-left icon" @click="handlerBack"></i
        >{{ this.$route.params.id ? $t('payroll_salary_25') : $t('payroll_wage_11') }}</span
      >
    </h2>
    <div class="wrap1-box wrap1-btn">
      <el-steps class="steps" :active="activeStep" align-center finish-status="success">
        <el-step v-for="item in tabPaneArr" :key="item.id" :title="$t(item.name)"></el-step>
      </el-steps>
      <component
        class="ruleForm"
        v-if="activeObj.comp"
        :is="activeObj.comp"
        :ref="activeObj.title"
        :activeData="activeData"
        :activeObj="activeObj"
        @handleAdd="handleAdd"
      ></component>
    </div>
    <el-row class="flex-btn">
      <!-- 上一步 -->
      <el-button v-if="activeStep > 0" size="small" @click="prev">{{ $t('422') }}</el-button>
      <!-- 下一步 -->
      <el-button v-if="activeStep !== tabPaneArr.length - 1" size="small" type="primary" @click="next">{{
        $t('331')
      }}</el-button>
      <!-- 保存 -->
      <el-button
        v-if="activeStep === tabPaneArr.length - 1"
        size="small"
        :disabled="scheme_id || calculate_state"
        @click="onSave()"
        >{{ $t('1907') }}</el-button
      >
      <!-- 去算薪 -->
      <el-button
        v-if="activeStep === tabPaneArr.length - 1"
        size="small"
        :disabled="scheme_id"
        type="primary"
        @click="onSave('salary')"
        >{{ $t('payroll_wage_10') }}</el-button
      >
    </el-row>
  </div>
</template>

<script>
import { tabPaneArr, data } from './conf'
import { payrollSubProjectInfo } from '@/api/payroll'
import rdiff from 'recursive-diff'
export default {
  data() {
    return {
      loading: false,
      activeStep: 0,
      activeObj: {},
      tabPaneArr,
      activeData: JSON.parse(JSON.stringify(data)),
      id: Number(this.$route.params.id),
      dialogVisible: false,
      change_nosave: true,
      confirm: false,
      info: JSON.parse(JSON.stringify(data.info))
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false)
    if (this.confirm) next()
    else {
      const diff = rdiff.getDiff(this.activeData.info, this.info)
      if (!diff.length) next()
      else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        })
          .then(() => {
            next()
          })
          .catch(() => {})
      }
    }
  },
  computed: {
    calculate_state() {
      const calculate_state = Number(this.activeData.info.calculate_state)
      return [3, 4].includes(calculate_state)
    },
    scheme_id() {
      return !Number(this.activeData.payroll_sub_project_scheme_id)
    }
  },
  mounted() {
    this.inif()
    this.preventBack()
  },
  methods: {
    preventBack() {
      const this_ = this
      window.pushStateFun = function () {
        const diff = rdiff.getDiff(this_.activeData.info, this_.info)
        if (!diff.length) this_.handlerBack()
        else {
          this_
            .$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
              confirmButtonText: this_.$t('submit_btn'),
              cancelButtonText: this_.$t('cancel_btn'),
              type: 'warning'
            })
            .then(() => {
              this_.confirm = true
              this_.handlerBack()
            })
            .catch(() => {
              const state = {
                title: null,
                url: document.UTL // 要禁掉的页面
              }
              /*
                  三个参数：
                  state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                  title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                  url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
                */
              window.history.pushState(state, null, document.UTL) // 要禁掉的页面
            })
        }
      }
      const state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      }
      window.history.pushState(state, null, document.UTL) // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false)
    },
    inif() {
      if (!this.$route.params.id) this.id = this.$s.get('sub_project_id')
      if (this.id) {
        this.activeData.sub_project_id = this.id
        this.loadSubProjectInfo(this.id)
      }
      this.activeObj = this.tabPaneArr[this.activeStep]
    },
    async loadSubProjectInfo(id) {
      // 获取子项目信息
      let res = {
        code: 1,
        data: {}
      }
      res = await payrollSubProjectInfo({
        sub_project_id: id
      })
      if (res && res.code === 1) {
        const department_ids = []
        if (res.data.department_ids && res.data.department_ids.length) {
          res.data.department_ids.forEach(item => {
            department_ids.push({
              department_id: item.id,
              department_name: item.name
            })
          })
        }
        const staffs = []
        if (Array.isArray(res.data.staff_ids)) {
          res.data.staff_ids.forEach(item => {
            staffs.push({
              staff_id: item.staff_id || item.id,
              staff_name: item.staff_name || item.name,
              staff_name_en: item.staff_name_en,
              staff_name_secondary: item.staff_name_secondary,
              staff_name_th: item.staff_name_th || item.name,
              avatar_url: item.avatar_url || '',
              id: item.id || '',
              name: item.name || ''
            })
          })
        }
        res.data.department_ids = department_ids
        res.data.staff_ids = staffs
        // 在职状态
        const staff_state = res.data.staff_state && res.data.staff_state !== '0' ? res.data.staff_state.split(',') : []
        res.data.staff_state = staff_state
        // 员工属性
        const staff_formal =
          res.data.staff_formal && res.data.staff_formal !== '0' ? res.data.staff_formal.split(',') : []
        res.data.staff_formal = staff_formal
        // 税
        res.data.tax_deduction_status = ['3', '4'].includes(res.data.tax_deduction_status)
          ? res.data.tax_deduction_status
          : ''
        this.activeData.payroll_sub_project_scheme_id = res.data.payroll_sub_project_scheme_id
        this.activeData.info = res.data
        this.info = JSON.parse(JSON.stringify(res.data))
      }
    },
    handlerBack() {
      this.$router.push({
        path: '/payroll/wage',
        query: {
          name: this.$route.query.name
        }
      })
    },
    async prev() {
      // 上一步
      this.activeData.sub_project_id = this.$s.get('sub_project_id') || this.id
      this.confirm = false
      this.activeStep--
      this.activeObj = this.tabPaneArr[this.activeStep]
    },
    async next() {
      // 下一步
      this.activeData.sub_project_id = this.$s.get('sub_project_id') || this.id
      let res
      try {
        this.loading = true
        if (this.activeObj.title === 'step1') {
          res = await this.$refs[this.activeObj.title].saveData()
        }
        if (res) {
          this.confirm = true
          this.$message({ type: 'success', message: this.$t('160') }) // 保存成功
          this.activeStep++
          this.activeObj = this.tabPaneArr[this.activeStep]
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        res = e
      }
    },
    async onSave(val) {
      // 保存
      let res
      try {
        if (this.calculate_state) {
          this.confirm = true
          this.$router.push({
            path: '/payroll/wageSalary/' + (this.$s.get('sub_project_id') || this.id),
            query: {
              name: this.$route.query.name
            }
          })
          return
        }
        res = await this.$refs[this.activeObj.title].saveData()
        if (res && res.code === 1) {
          this.confirm = true
          this.$message({ type: 'success', message: this.$t('160') })
          if (val) {
            this.$router.push({
              path: '/payroll/wageSalary/' + (this.$s.get('sub_project_id') || this.id),
              query: {
                name: this.$route.query.name
              }
            })
          }
        }
      } catch (e) {
        res = e
      }
    },
    handleAdd() {
      this.confirm = true
      this.$router.push('/payroll/salary-scheme')
    }
  },
  beforeDestroy() {
    // 删除本地存储的sub_project_id
    this.$s.remove('sub_project_id')
  }
}
</script>

<style lang="scss" scoped>
.wrap1-box {
  /deep/ .steps {
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;
    box-sizing: border-box;
    .el-step__head {
      &.is-success {
        color: #f0f0f0;
        border-color: #f0f0f0;
        border-width: 1px;
        .el-step__line {
          height: 1px;
          background: #f0f0f0;
        }
        .is-text {
          background: #fff;
          border-color: #5D51DA;
          .el-step__icon-inner {
            color: #5D51DA;
          }
        }
      }
      &.is-process,
      &.is-finish {
        .is-text {
          background: #5D51DA;
          border-color: #5D51DA;
        }
        .el-step__icon-inner {
          color: #fff;
        }
      }
    }
    .el-step__line {
      height: 1px;
      background: #f0f0f0;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      border: 1px solid;
    }
    .el-step__main {
      .is-wait {
        font-size: 16px;
        color: #8c8c8c;
      }
      .is-finish {
        font-size: 16px;
        color: #262626;
      }
      .is-success {
        font-size: 16px;
        color: #595959;
      }
    }
  }
  /deep/ .el-input {
    min-width: 408px;
  }
  .el-date-editor {
    min-width: 408px;
  }
  .ruleForm {
    padding-top: 24px;
  }
}
</style>
